// @ts-strict-ignore
import cross from '@/assets/svg/cross.svg'
import Image from 'next/image'
import React from 'react'

import { TCartItem, useCart } from '@/entities/cart'

import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Icon } from '@/shared/ui/icon'

import cls from './applied-service-item.module.scss'

type AppliedServiceItemProps = {
	service: TCartItem
	relatedId: number
}

const POLICE_IMG_SRC = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/services/police.jpg`
const CARD_IMG_SRC = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/services/card.jpg`

export const AppliedServiceItem = ({ service, relatedId }: AppliedServiceItemProps): JSX.Element => {
	const { deleteItem } = useCart()

	const handleRemoveService = () => {
		deleteItem(service.ID_BASKET, relatedId)
	}

	const image = service.TITLE.includes(`iPort`) ? CARD_IMG_SRC : POLICE_IMG_SRC

	return (
		<div className={cls.appliedServiceItem}>
			<Image
				src={image}
				width={40}
				height={40}
				quality={100}
				loading="lazy"
				aria-hidden
				alt={service.TITLE}
				className={cls.image}
			/>
			<div className={cls.mobileAlign}>
				<span className={cls.title}>{service.TITLE}</span>
				<span className={cls.price}>{formatPrice(service.PRICE.VALUE, `decimal`)} ₽</span>
			</div>
			<button className={cls.removeButton} onClick={handleRemoveService}>
				<Icon icon={cross} aria-hidden={true} />
			</button>
		</div>
	)
}
